export { ALLOWED_VIEW_TYPES, default as HeadingWithBreadcrumb } from "./HeadingWithBreadcrumb";
